export const links = {
    googleMaps: "https://www.google.com/maps/place/49%C2%B035'09.5%22N+34%C2%B032'56.3%22E/@49.5859756,34.5463973,17z/data=!3m1!4b1!4m4!3m3!8m2!3d49.5859722!4d34.5489722?entry=ttu",
}